import LayoutBeautyInsider from 'components/Content/ContentLayout/LayoutBeautyInsider/LayoutBeautyInsider';

export default LayoutBeautyInsider;
